import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Stack, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { SettingsBox } from 'src/Elements/Data'
import BatteryTrainingModeIndicator from './settings/BatteryTrainingModeIndicator'
import { makeStyles } from 'tss-react/mui'
import { useUser } from 'src/Hooks/useUser'
import { BatteryTrainingMode, BatteryTrainingModes } from 'src/Libs/system-data-handler'

const useStyles = makeStyles()(theme => ({
  stackContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row-reverse',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(2),
  },
  buttonsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginLeft: 'auto',
    },
  },
}))

interface Props {
  batteryTrainingMode: BatteryTrainingMode
  onUpdate: (trainingMode: boolean) => void
  disabledActions: boolean
}

const BatteryTrainingData: React.VFC<Props> = ({ batteryTrainingMode, onUpdate, disabledActions }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { breakpoints } = useTheme()
  const { userData } = useUser()
  const isUserLevelUser = userData?.level === 'USER'

  const fullWidthButtons = useMediaQuery(breakpoints.down('md'))

  return (
    <Box>
      <Stack padding={4} paddingBottom={0} paddingTop={2}>
        <SettingsBox
          title={t('settings.battery.battery-training.status.title')}
          suffix={<BatteryTrainingModeIndicator trainingMode={batteryTrainingMode} />}
        />
      </Stack>
      {!isUserLevelUser && (
        <Stack className={classes.stackContainer}>
          <Stack className={classes.buttonsWrapper}>
            <Button
              type="button"
              color="primary"
              variant="contained"
              size="large"
              disabled={disabledActions || batteryTrainingMode === BatteryTrainingModes.Inactive}
              onClick={() => onUpdate(false)}
              fullWidth={fullWidthButtons}
            >
              {t('shell.stop')}
            </Button>
            <Button
              type="button"
              variant="contained"
              color="primary"
              size="large"
              disabled={disabledActions || batteryTrainingMode === BatteryTrainingModes.Active}
              onClick={() => onUpdate(true)}
              fullWidth={fullWidthButtons}
            >
              {t('shell.start')}
            </Button>
          </Stack>
        </Stack>
      )}
    </Box>
  )
}

export default BatteryTrainingData
